export default "__VITE_ASSET__BJp5ZpmL__"